import apiService from './api.service';

export interface Alert {
  id: string;
  tenant_id: string;
  application_id?: string;
  name: string;
  description?: string;
  alert_type: 'metric' | 'log' | 'trace' | 'anomaly';
  conditions: object;
  severity: 'low' | 'medium' | 'high' | 'critical';
  status: 'active' | 'inactive';
  notification_channels?: object;
  last_triggered_at?: string;
  trigger_count: number;
  created_at: string;
  updated_at: string;
}

export interface CreateAlertRequest {
  applicationId?: string;
  name: string;
  description?: string;
  alertType: 'metric' | 'log' | 'trace' | 'anomaly';
  conditions: object;
  severity: 'low' | 'medium' | 'high' | 'critical';
  notificationChannels?: object;
}

export interface UpdateAlertRequest {
  name?: string;
  description?: string;
  conditions?: object;
  severity?: 'low' | 'medium' | 'high' | 'critical';
  status?: 'active' | 'inactive';
  notificationChannels?: object;
}

class AlertApi {
  async getAll(applicationId?: string, limit: number = 50, offset: number = 0): Promise<{ success: boolean; data: Alert[]; meta: { total: number; limit: number; offset: number } }> {
    return apiService.get('/v1/alerts', { params: { applicationId, limit, offset } });
  }

  async getById(id: string): Promise<{ success: boolean; data: Alert }> {
    return apiService.get(`/v1/alerts/${id}`);
  }

  async create(data: CreateAlertRequest): Promise<{ success: boolean; data: Alert }> {
    return apiService.post('/v1/alerts', data);
  }

  async update(id: string, data: UpdateAlertRequest): Promise<{ success: boolean; data: Alert }> {
    return apiService.put(`/v1/alerts/${id}`, data);
  }

  async delete(id: string): Promise<{ success: boolean; message: string }> {
    return apiService.delete(`/v1/alerts/${id}`);
  }
}

export default new AlertApi();
